import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hidePhoneNumber',
})
export class HidePhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    if (phoneNumber && phoneNumber.length >= 3) {
      const hiddenPart = '*'.repeat(phoneNumber.length - 3); // Replace all but the last 3 digits with asterisks
      const lastThreeDigits = phoneNumber.slice(-3); // Get the last 3 digits
      return hiddenPart + lastThreeDigits;
    } else {
      // Return the original input if it's not a valid phone number.
      return phoneNumber;
    }
  }
}
